"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Workflows API
 * Create and manage pipelines
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var EnumTaskType;
(function (EnumTaskType) {
    EnumTaskType["ImageBuild"] = "image_build";
    EnumTaskType["ContainerRun"] = "container_run";
    EnumTaskType["Request"] = "request";
    EnumTaskType["TapisJob"] = "tapis_job";
    EnumTaskType["TapisActor"] = "tapis_actor";
    EnumTaskType["Function"] = "function";
})(EnumTaskType = exports.EnumTaskType || (exports.EnumTaskType = {}));
function EnumTaskTypeFromJSON(json) {
    return EnumTaskTypeFromJSONTyped(json, false);
}
exports.EnumTaskTypeFromJSON = EnumTaskTypeFromJSON;
function EnumTaskTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EnumTaskTypeFromJSONTyped = EnumTaskTypeFromJSONTyped;
function EnumTaskTypeToJSON(value) {
    return value;
}
exports.EnumTaskTypeToJSON = EnumTaskTypeToJSON;
